enum AppAdminList {
  Incidents = 'Incidents',
  Positions = 'Positions',
  ControlPanel = 'Control Panel',
}

export default AppAdminList;
